function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { StateHandler, controllerMixin } from 'oskari-ui/util';
var UIHandler = /*#__PURE__*/function (_StateHandler) {
  function UIHandler(tools, consumer) {
    var _this;
    _classCallCheck(this, UIHandler);
    _this = _callSuper(this, UIHandler);
    _this.toolsToInit = tools ? _toConsumableArray(tools) : [];
    _this.setState({
      tools: []
    });
    _this.addStateListener(consumer);
    return _this;
  }
  _inherits(UIHandler, _StateHandler);
  return _createClass(UIHandler, [{
    key: "init",
    value: function init(data) {
      this.data = data;
      while (this.toolsToInit.length) {
        var tool = this.toolsToInit.shift();
        try {
          tool.init(data);
          if (tool.isDisplayed(data)) {
            this._addToolToState(tool);
          }
        } catch (err) {
          Oskari.log('ToolPanelHandler').error('Error initializing publisher tool:', tool);
        }
      }
      var _this$getState = this.getState(),
        tools = _this$getState.tools;
      return tools.length > 0;
    }
  }, {
    key: "_addToolToState",
    value: function _addToolToState(tool) {
      var _this2 = this;
      var toolComponent = tool.getComponent();
      if (toolComponent.handler) {
        toolComponent.handler.addStateListener(function () {
          return _this2.notify();
        });
      }
      var _tool$getTool = tool.getTool(),
        id = _tool$getTool.id,
        title = _tool$getTool.title,
        hideCheckbox = _tool$getTool.hideCheckbox;
      this.updateState({
        tools: [].concat(_toConsumableArray(this.state.tools), [{
          id: id,
          title: title,
          hideCheckbox: hideCheckbox,
          component: toolComponent.component,
          handler: toolComponent.handler,
          publisherTool: tool
        }])
      });
    }
  }, {
    key: "setToolEnabled",
    value: function setToolEnabled(tool, enabled) {
      tool.setEnabled(enabled);
      // trigger re-render
      this.notify();
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this$getState2 = this.getState(),
        tools = _this$getState2.tools;
      tools.forEach(function (tool) {
        try {
          tool.publisherTool.stop();
        } catch (e) {
          Oskari.log('Publisher.ToolPanelHandler').error('Error stopping publisher tool:', tool.id);
        }
      });
    }
  }]);
}(StateHandler);
;
var wrapped = controllerMixin(UIHandler, ['setToolEnabled']);
export { wrapped as ToolPanelHandler };